module.exports = __webpack_public_path__ + "static/media/point.a7f026e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/point.png
// module id = 245
// module chunks = 0